import "../App.css";
import React from "react";
import SearchScreen from "./Search";
import IntroPage from "./IntroPage"
import { Routes, Route } from "react-router-dom";
import { Analytics } from '@vercel/analytics/react';

function App() {
  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<IntroPage />} />
        <Route path="/:dbName" element={<SearchScreen />} />
        <Route path="/:dbName/:videoId" element={<SearchScreen />} />
      </Routes>
      <Analytics />
    </div>
  );
}

export default App;